import { Controller } from "@hotwired/stimulus"
import { EnhancedSelect } from "../utils/enhanced_select"

export default class SelectController extends Controller<HTMLSelectElement> {
  static values = {
    placeholder: String,
    allowClear: { type: Boolean, default: true },
    closeOnSelect: { type: Boolean, default: true },
    maxItems: Number,
  }

  static targets = ["dropdownParent"]

  declare placeholderValue: string
  declare allowClearValue: boolean
  declare closeOnSelectValue: boolean
  declare maxItemsValue: number
  declare hasMaxItemsValue: boolean
  declare hasDropdownParentTarget: boolean
  declare dropdownParentTarget: HTMLElement

  private enhancedSelect?: EnhancedSelect

  connect(): void {
    this.initSelect()
  }

  disconnect(): void {
    this.destroySelect()
  }

  private initSelect(): void {
    this.enhancedSelect = new EnhancedSelect(this.element, {
      placeholder: this.placeholderValue,
      allowClear: this.allowClearValue,
      closeOnSelect: this.closeOnSelectValue,
      maxItems: this.hasMaxItemsValue ? this.maxItemsValue : undefined,
      dropdownParent: this.hasDropdownParentTarget ? this.dropdownParentTarget : undefined,
      onItemAdd: (value) => this.dispatch("select", { detail: { value } }),
      onItemRemove: (value) => this.dispatch("remove", { detail: { value } }),
      onChange: (value) => this.dispatch("change", { detail: { value: String(value) } }),
      onClear: () => this.dispatch("clear"),
    })
  }

  private destroySelect(): void {
    if (this.enhancedSelect) {
      this.enhancedSelect.destroy()
      this.enhancedSelect = undefined
    }
  }

  // Public API
  getValue(): string | string[] {
    return this.enhancedSelect?.getValue() ?? ""
  }

  setValue(value: string | string[], silent = true): void {
    this.enhancedSelect?.setValue(value, silent)
  }

  clearValue(silent = true): void {
    this.enhancedSelect?.clear(silent)
  }

  reset(silent = true): void {
    this.clearValue(silent)
  }

  addOption(data: { value: string; text: string }): void {
    this.enhancedSelect?.addOption(data)
  }
}
